import { Box, SvgIcon } from '@mui/material';
import { ComponentType } from 'react';
import { SizingMultiplier, Typography } from '@ocx/ui';

export type FormIconHelperTextProps = {
  icon: ComponentType;
  text: string;
};

export const FormIconHelperText = ({ text, icon: FormIcon }: FormIconHelperTextProps) => (
  <Box display="flex" alignItems="center" marginTop={SizingMultiplier.xs}>
    <SvgIcon component={FormIcon} sx={{ flexShrink: 0, color: 'text.disabled', width: 16, height: 16 }} />
    <Typography color="textSecondary" variant="caption" marginLeft={SizingMultiplier.sm}>
      {text}
    </Typography>
  </Box>
);
